/**
 * Resolução única do id do cliente cuja carteira está aberta.
 *
 * As duas superfícies de sugestões leem o MESMO objeto — `store.getters['user/currentClient']`,
 * seja via `$currentClient()` (a aba) ou via a prop `clienteAtual` que desce do shell da rota (a
 * tabela). Cada uma resolvia o id à sua maneira, e a divergência é o tipo de coisa que só aparece
 * no dia em que o shape do cliente muda em um caminho e não no outro.
 *
 * `id_cliente_app` vem primeiro porque é o nome do campo no contrato da fila; `id` é como o store
 * grava hoje. Ausência dos dois devolve `null`, nunca `undefined`, para o chamador poder
 * distinguir "não há cliente" de "não perguntei".
 */
export const idDaCarteira = (cliente) => {
  const dono = cliente || {}
  const id = dono.id_cliente_app || dono.id
  return id === undefined || id === null ? null : id
}
